import axios from 'axios'
import qs from 'qs'
import get from 'lodash/get'
import includes from 'lodash/includes'

const STORAGE_NAME = `carpool_${process.env.VUE_APP_WEB}`;

export default {
  namespace: true,
  state: {
    books: [],
    schedules: [],
    loading: false,
    loadingSchedule: false
  },
  getters: {
    books(state) {
      return state.books
    },
    schedules(state) {
      return state.schedules
    },
    loadingSchedule(state) {
      return state.loadingSchedule
    }
  },
  mutations: {
    CLEAR_BOOKS(state) {
      state.books.splice(0)
    },
    ADD_BOOK_TO_LIST(state, book) {
      state.books.push(book)
    },
    CLEAR_SCHEDULES(state) {
      state.schedules.splice(0)
    },
    ADD_SCHEDULE_TO_LIST(state, schedule) {
      state.schedules.push(schedule)
    },
    SET_LOADING_SCHEDULE(state, loadingSchedule) {
      state.loadingSchedule = loadingSchedule
    }
  },
  actions: {
    LOAD_BOOKS({ commit }, payload) {
      const query = qs.stringify(payload)
      const url   = `${process.env.VUE_APP_API_URL}/get_booking_information`
      return axios.post(url, query)
        .then((response) => {
          if (response) {
            const errorList = [
              'Please login first.',
              'Token not found or you session has ended.',
              'Your session has ended, please relogin.'
            ]
            const message = get(response, 'data.data.message', '')
            if (includes(errorList, message)) {
              return new Promise((resolve, reject) => {
                try {
                  localStorage.removeItem(`USER_DATA_${STORAGE_NAME}`)
                } catch (e) {}
                resolve();
              })
              .then(() => {
                window.location.reload()
              })
            } else {
              const { data: { data: books } } = response
              books.forEach((book) => {
                commit('ADD_BOOK_TO_LIST', book)
              })
            }
          }
        })
    },
    LOAD_SCHEDULES({ commit }, payload) {
      const query = qs.stringify(payload)
      const url   = `${process.env.VUE_APP_API_URL}/get_schedules`
      commit('SET_LOADING_SCHEDULE', true);
      return axios.post(url, query)
        .then(response => {
          if (response) {
            const { data: { data: schedules } } = response
            schedules.forEach((schedule) => {
              commit('ADD_SCHEDULE_TO_LIST', schedule)
            })
          }
          commit('SET_LOADING_SCHEDULE', false);
        })
    }
  }
}
